import React, { PureComponent } from 'react';

import moment from 'moment';

import { Endpoint, ReportService } from '@philips-emr/hpms-stipulator-commons';
import { Button, Card, ContextMenu, Field, Image, Option, Stamp, Text, Tooltip, TooltipTrigger } from '@philips-emr/tws-components';
import { Breakpoint, Placement } from '@philips-emr/tws-constants';
import { AwesomeComponent, ComponentType } from '@philips-emr/tws-core';
import { eventListener, number, string } from '@philips-emr/tws-core/lib/component/prop-types';
import { HistoryService, HttpService } from '@philips-emr/tws-core/lib/services';
import { msg } from '@philips-emr/tws-core/lib/services/message-service';
import { format } from '@philips-emr/tws-core/lib/services/model-service';
import { getBreakpoint, isEmptyOrBlankString } from '@philips-emr/tws-utils';

import { HpmsIndiceReajusteApi } from '../../api';
import './hpms-indice-reajuste.scss';

@AwesomeComponent({ type: ComponentType.DATA_DISPLAY, api: HpmsIndiceReajusteApi })
class HpmsIndiceReajuste extends PureComponent {

  static propTypes = {
    nrSeqReajDoc: number,
    nrSeqContrato: number,
    dtMesReajuste: string,
    ieStatus: string,
    txReajust: string,
    dtLiberacaoExtrato: string,
    ieApresentarDtLibReajuste: string,
    dsArquivo: string,
    onOpenAttachment: eventListener,
    onOpenModalDocumento: eventListener,
    nrSeqRelatorio: number,
    dsTipoContratacao: string,
    iePossuiArquivo: string,
  };

  render() {
    if (this.isMobile()) {
      return this.renderMobile();
    }

    return this.renderDefault();
  }

  renderMobile() {
    const { dtLiberacaoExtrato, ieStatus, dsTipoContratacao } = this.props;
    const { nrSeqReajDoc, iePossuiArquivo, nrSeqRelatorio, dsArquivo } = this.props;

    const txReajuste = this.getValueTxReajuste();

    return (
      <Card width={12} className="c-indice-reajuste-mobile" ieStatus={ieStatus} superscriptionEntry="ieStatus" superscription={this.getSupercriptions()}>
        <div className={`c-indice-reajuste-mobile__card-interior`}>
          <div className="c-indice-reajuste-mobile__content-section">
            <div className="c-indice-reajuste-mobile__card-wrap">
              <div className="c-indice-reajuste-mobile__card-header">
                <div>
                  {msg('$expression.$325952')} <span className="u-text-bold">{this.stringDtMesReajusteToMothYear()}</span>
                </div>
                <div className="c-indice-reajuste-mobile__card-header-actions">
                  <ContextMenu placement={Placement.RIGHT}>
                    <Option onClick={() => this.onOpenModalDocumento({ nrSeqReajDoc })} visible="true" value={msg('stipulator.detalhes')} />
                    <Option onClick={(event) => this.onOpenAttachment({ nrSeqReajDoc, dsArquivo }, event)} visible={iePossuiArquivo == 'S'} value="Downlaod" />
                    <Option onClick={() => this.onPrint({ nrSeqReajDoc, nrSeqRelatorio })} visible="true" value={msg('stipulator.imprimir')} />
                  </ContextMenu>
                </div>
              </div>
              <div className="c-indice-reajuste-mobile__card-content-row-center c-indice-reajuste-mobile__card-content">
                <div className="c-indice-reajuste-mobile__card-content-status">
                  {this.getSvg()}
                </div>
                <div className="c-indice-reajuste-mobile__card__content-reajust__field">
                  {
                    isEmptyOrBlankString(txReajuste) ? null : (
                      <Field width={12} label={msg('$expression.$297257')}>
                        <Text bold={true} className="c-text-black" value={this.getValueTxReajuste()} size="2lg" />
                      </Field>
                    )
                  }
                </div>
              </div>
              {
                this.showDataLibReajuste() && dtLiberacaoExtrato ? (
                  <div className="c-indice-reajuste-mobile__card-content-row-center c-indice-reajuste-mobile__card-content">
                    {`${msg('$expression.$940305')} ${format('date', dtLiberacaoExtrato)}`}
                  </div>
                ) : (
                    <div className="c-indice-reajuste-mobile__card-content-silence"></div>
                  )
              }

              <div className="c-indice-reajuste__card-content" >
                <Field width={2}>
                </Field>
                <Field width={2} hideLabel={true}>
                  <Stamp icon={this.getSvgStatus()} color={this.getColorStatus()} label={dsTipoContratacao} className=".c-indice-reajuste__card-content" />
                </Field>
              </div>
            </div>

          </div>
        </div>
      </Card>
    );
  }

  renderDefault() {
    const { dtLiberacaoExtrato, ieStatus, dsTipoContratacao } = this.props;
    const actions = this.getActions();
    const txReajuste = this.getValueTxReajuste();
    const dateFormatter = { value: { name: 'date' } };
    const wrapClassName = `c-indice-reajuste__card-wrap ${!this.showDataLibReajuste() && 'c-indice-reajuste__card-wrap__hide-reajuste-column'}`;

    return (
      <Card ieStatus={ieStatus} width={12} className="c-indice-reajuste-card" superscriptionEntry="ieStatus" superscription={this.getSupercriptions()} >
        <div className={wrapClassName}>
          <div className="c-indice-reajuste__card-">
            <div className="c-indice-reajuste__card-sub-description">
              <Tooltip value={this.getLabelTooltip()} trigger={TooltipTrigger.HOVER}>
                <div>
                  {this.getSvg()}
                </div>
              </Tooltip>
            </div>
          </div>

          <div className="c-indice-reajuste__card-">
            <Field width={12} label={msg('$expression.$325952')}>
              <Text className="c-text-black" value={this.stringDtMesReajusteToMothYear()} />
            </Field>
          </div>

          <div className="c-indice-reajuste__card-taxa-reajuste">
            <div className="c-indice-reajuste__card-align-item-right-size">
              {
                !isEmptyOrBlankString(txReajuste) && (
                  <Field width={12} label={msg('$expression.$297257')}>
                    <Text bold className="c-text-black" value={txReajuste} />
                  </Field>
                )
              }
            </div>
          </div>
          {this.showDataLibReajuste() &&
            <div className="c-indice-reajuste__card-column">
              <div className="c-indice-reajuste__card-align-item-right-size">
                <Field width={12} label={msg('$expression.$940305')} formatters={dateFormatter}>
                  <Text className="c-text-black" value={dtLiberacaoExtrato} />
                </Field>
              </div>
            </div>
          }
          <div className="c-indice-reajuste__card-content" >
            <Field width={12} hideLabel={true}>
              <Stamp icon={this.getSvgStatus()} color={this.getColorStatus()} label={dsTipoContratacao} className=".c-indice-reajuste__card-content" />
            </Field>
          </div>
          <div className="c-indice-reajuste__card-column">
            <div className="c-indice-reajuste__card-content__action">
              {actions}
            </div>
          </div >
        </div>
      </Card >
    );
  }

  getActions() {
    const { nrSeqReajDoc, iePossuiArquivo, nrSeqRelatorio, dsArquivo } = this.props;
    const actions = [];

    actions.push(
      <Button
        key="report"
        icon="/static/assets/report.svg"
        theme="quiet-emphasis"
        value=""
        iconPlacement="left"
        onClick={() => this.onOpenModalDocumento({ nrSeqReajDoc })}
      />
    );

    if (iePossuiArquivo == 'S') {
      actions.push(
        <Button
          key="download"
          icon="/static/assets/download-gray.svg"
          theme="quiet-emphasis"
          value=""
          iconPlacement="left"
          onClick={(event) => this.onOpenAttachment({ nrSeqReajDoc, dsArquivo }, event)}
        />
      );
    }

    actions.push(
      <Button
        key="hpms-print"
        icon="/static/assets/hpms-print-gray.svg"
        theme="quiet-emphasis"
        value=""
        iconPlacement="left"
        onClick={() => this.onPrint({ nrSeqReajDoc, nrSeqRelatorio })}
      />
    );
    return actions;
  }

  onOpenAttachment = (obj, event) => {
    const { onOpenAttachment } = this.props;
    if (event) {
      event.stopPropagation();
    }

    onOpenAttachment && onOpenAttachment({ value: obj });
  }

  onOpenModalDocumento = (nrSeqReajDocObj) => {
    const { onOpenModalDocumento } = this.props;

    onOpenModalDocumento && onOpenModalDocumento({ value: nrSeqReajDocObj });
  }

  onPrint(dados) {
    const { nrSeqReajDoc, nrSeqRelatorio } = dados;
    const { nrSeqContrato } = HistoryService.getCurrentRouteParams();

    const reportService = new ReportService();

    let params = {
      nrSeqContrato: nrSeqContrato,
      NR_SEQUENCIA: nrSeqReajDoc,
    };

    if (nrSeqRelatorio) {

      HttpService.get(Endpoint.GET.DADOS_RELATORIO_BY_SEQ, { nrSeqContrato, nrSeqRelatorio })
        .then(response => {
          const { cdClassifRelat, cdRelatorio } = response.body;
          reportService.gerarRelatorio(cdRelatorio, cdClassifRelat, params);
        });

    } else {
      reportService.gerarRelatorio('4873', 'WPLS', params);
    }

  }

  getSupercriptions() {
    return [
      {
        value: '1',
        color: '#008ee8',
      },
      {
        value: '2',
        color: '#3fb763',
      },
      {
        value: '3',
        color: '#ff9514',
      },
    ];
  }

  getSvg() {
    const ieStatus = this.getStatus();

    const breakpoints = getBreakpoint();
    if (breakpoints == 'sm' || breakpoints == 'xsm') {
      return null;
    }

    switch (ieStatus) {
      case '1':
        return <Image src="/static/assets/cicle-money-clock-40-40.svg" />;
      case '2':
        return <Image src="/static/assets/cicle-money-check-40-40.svg" />;
      case '3':
        return <Image src="/static/assets/cicle-money-40-40.svg" />;
      default:
        return null;
    }
  }

  getSvgStatus() {
    const ieStatus = this.getStatus();

    switch (ieStatus) {
      case '1':
        return 'waiting';
      case '2':
        return 'check';
      case '3':
        return 'warning';
      default:
        return null;
    }
  }

  getColorStatus() {
    const ieStatus = this.getStatus();

    switch (ieStatus) {
      case '1':
        return 'safety_blue';
      case '2':
        return 'safety_green';
      case '3':
        return 'safety_red';
      default:
        return null;
    }
  }

  getLabelTooltip() {
    const ieStatus = this.getStatus();

    switch (ieStatus) {
      case '1':
        return '@status.lote-reajuste/1';
      case '2':
        return '@status.lote-reajuste/2';
      case '3':
        return '@status.lote-reajuste/3';
      default:
        return null;
    }
  }

  getStatus() {
    const { ieStatus } = this.props;

    return ieStatus;
  }

  isMobile() {
    return getBreakpoint() !== Breakpoint.LG
  }

  showDataLibReajuste() {
    const { ieApresentarDtLibReajuste } = this.props;
    return ieApresentarDtLibReajuste === 'S';
  }

  getValueTxReajuste() {
    const { txReajust } = this.props;

    if (isEmptyOrBlankString(txReajust)) {
      return '';
    }

    return txReajust + '%';
  }

  stringDtMesReajusteToMothYear() {
    const { dtMesReajuste } = this.props;

    if (isEmptyOrBlankString(dtMesReajuste)) {
      return null;
    }

    try {
      return moment(dtMesReajuste, 'DD/MM/YY').format('MM/YYYY');
    } catch (error) {
      console.error(error);
    }

    return null;
  }

}

export default HpmsIndiceReajuste;
